module.exports = __webpack_public_path__ + "img/antes_despues_47.626ad73a.png";